import React from 'react';

import logoTVI from '../images/header/logo_thaivivat.svg'

function Header() {
  
  return (
  <div className="w-full bg-green-500 flex font-prompt">
    <div className='flex w-full   py-4 pl-4 md:pl-12  lg:w-1092 lg:pl-0 lg:mx-auto'>
      <img src={logoTVI} alt="logo Thaivivat" />
    </div>
  </div>
  )
}

export default Header;